import { Alert, Dialog, MenuItem, SelectField, Stack, TextField } from '@all-manager/design-system-v2';
import { Controller } from 'react-hook-form';
import { QuoteCompaisonColumnDatabase, QuoteCompaisonColumnType } from '../../../../types';
import { COLUMN_TYPE_LABELS, COLUMN_TYPES } from '../../utils/columnTypes';
import { useQuoteColumnFormDialog } from './useQuoteColumnFormDialog';

type Props = {
  groupId: string;
  nextOrder: number;
  column?: QuoteCompaisonColumnDatabase;
  onClose: () => void;
};

export default function QuoteColumnFormDialog(props: Props) {
  const hook = useQuoteColumnFormDialog(props);

  return (
    <Dialog
      open
      onClose={hook.handleClose}
      onSubmit={hook.onSubmit}
      maxWidth="xs"
      fullWidth
      title={hook.isEdition ? 'Modifier le critère' : 'Nouveau critère'}
      closeLabel="Fermer"
      actions={{
        primaryAction: {
          label: hook.isEdition ? 'Enregistrer le critère' : 'Ajouter le critère',
          type: 'submit',
          loading: hook.isPending,
        },
        secondaryAction: {
          label: 'Annuler',
          onClick: hook.handleClose,
          disabled: hook.isPending,
        },
      }}
    >
      <Stack spacing={2}>
        {hook.serverError ? <Alert severity="error">{hook.serverError}</Alert> : null}

        <Controller
          control={hook.form.control}
          name="label"
          render={({ field, fieldState }) => (
            <TextField
              name={field.name}
              inputRef={field.ref}
              onBlur={field.onBlur}
              onChange={field.onChange}
              value={field.value}
              label="Nom"
              placeholder="Ex. : Délai d'intervention"
              fullWidth
              required
              autoFocus
              error={!!fieldState.error}
              helperText={fieldState.error?.message}
            />
          )}
        />

        <Controller
          control={hook.form.control}
          name="type"
          render={({ field }) => (
            <SelectField<QuoteCompaisonColumnType>
              name={field.name}
              inputRef={field.ref}
              onBlur={field.onBlur}
              onChange={(event) => field.onChange(event.target.value)}
              value={field.value}
              label="Type de valeur"
              fullWidth
              helperText="Un montant est affiché en euros et mis en avant dans la comparaison."
            >
              {COLUMN_TYPES.map((type) => (
                <MenuItem key={type} value={type}>{COLUMN_TYPE_LABELS[type]}</MenuItem>
              ))}
            </SelectField>
          )}
        />
      </Stack>
    </Dialog>
  );
}
